import React from 'react';
import { useLocation } from 'react-router-dom';
import { getPublicPageSeo } from '../../../seo/publicPages';
import { usePageBanners } from '../../../hooks/usePageBanners';
import PageBanner from '../PageBanner/PageBanner';
import './AboutHero.css';

const SECTION = 'About Us';

const AboutHero = () => {
  const { pathname } = useLocation();
  const heading = getPublicPageSeo(pathname)?.heading || 'About Us';
  const { hasDynamicBanner, banners } = usePageBanners(SECTION);
  const titleSectionClass = hasDynamicBanner
    ? 'about-hero-title-section about-hero-title-section--below-banner'
    : 'about-hero-title-section about-hero-title-section--standalone';

  return (
    <section className="about-hero">
      {hasDynamicBanner && <PageBanner banners={banners} />}
      <div className={titleSectionClass}>
        <div className="container">
          <div className="about-hero-content">
            <h1 className="about-title">
              About Us
            </h1>
            <p className="about-subtitle">
              Your Business. One Flow
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutHero;
